import {Component, Inject, OnInit} from '@angular/core';
import {ConfService} from "../../conf.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

declare let $;

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {

  apiKey = localStorage.getItem('apikey');
  partner = localStorage.getItem('partner');
  account = localStorage.getItem('account');
  isExpanded = false;
  apiExecutor: any;
  loading = true;
  entityMethods: any;

  constructor(private confPost: ConfService,
              public platform: LeftpanelComponent,
              public dialogRef: MatDialogRef <DialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = true;
  }

  async ngOnInit() {
    this.data['url'] = 'https://' + await this.platform.getDefaultGatewayURL();
    if (this.data && this.data['type'] && this.data['type'] === 'dataaccess') {
      this.entityMethods = [];
      this.confPost.getEntity(this.data['partner'], this.data['account'], this.data['entityName'], this.data['version']).subscribe(resp => {
        if (resp && resp !== undefined && resp !== null && resp['methods'] && resp['methods'] !== null && resp['methods'] !== undefined) {
          this.entityMethods = resp['methods'];
          this.loading = false;
        } else {
          this.entityMethods = [];
          this.loading = false;
        }
      }, error => {
        this.entityMethods = [];
        this.platform.openSnackBar('Error in retrieving entity methods. Please try again sometime', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.loading = false;
      });

      // this.confPost.getApiExecutorsByPartnerAccountEntityVersion(this.data['partner'], this.data['account'], this.data['entityName'], this.data['version']).subscribe(response => {
      //   this.apiExecutor = response;
      //   this.loading = false;
      // }, error => {
      //   this.platform.openSnackBar('Error in retrieving APIs. Please try again sometime', 'Error', {
      //     duration: 5000,
      //     verticalPosition: 'top',
      //     horizontalPosition: 'center'
      //   });
      //   this.loading = false;
      // });
    } else {
      this.loading = false;
    }
  }

  toggleExecutor(ev) {
    $('.more-query-options').slideToggle();
    this.isExpanded = !this.isExpanded;
  }

  editAgain() {
    this.dialogRef.close('edit');
  }
  manageData() {
    this.dialogRef.close('data');
  }
  executeApi() {
    this.dialogRef.close('execute');
  }
  manageDocumentation() {
    this.dialogRef.close('devex');
  }
  manageDocumentationForApi() {
    this.dialogRef.close('devexApi');
  }
  generateExecutorAgain() {
    this.dialogRef.close('create');
  }
  // copyMessage(event) {
  //   const selBox = document.createElement('textarea');
  //   selBox.style.position = 'fixed';
  //   selBox.style.left = '0';
  //   selBox.style.top = '0';
  //   selBox.style.opacity = '0';
  //   selBox.value = $(event.target).text();
  //   document.body.appendChild(selBox);
  //   selBox.focus();
  //   selBox.select();
  //   document.execCommand('copy');
  //   document.body.removeChild(selBox);
  // }


  copyMessage(val) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = $(val).text();
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.platform.openSnackBar('CURL command copied to clipboard.', 'Success', {
      duration: 5000,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
    // alert('CURL command copied to clipboard');
  }

  setflag() {
    this.data.showNextPanel = true;
  }
  close() {
    this.dialogRef.close();
  }
  close1(str) {
    this.dialogRef.close(str);
  }
}
